import { render, staticRenderFns } from "./PaginationSearch.vue?vue&type=template&id=12e9a776&"
import script from "./PaginationSearch.vue?vue&type=script&lang=js&"
export * from "./PaginationSearch.vue?vue&type=script&lang=js&"
import style0 from "./PaginationSearch.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports